import { useTranslation } from 'react-i18next';
import { emailRegex } from 'helpers/utils';
import { useValidatedField } from './useValidatedField';
export const useEmail = (initialValue = '') => {
    const { t } = useTranslation('common');
    return useValidatedField(initialValue, {
        regex: emailRegex,
        errorMessage: t('accountDescriptions.email'),
    });
};
export const useUsername = () => {
    const { t } = useTranslation('common');
    return useValidatedField('', {
        regex: /^[A-Za-z0-9_-]{6,60}$/,
        errorMessage: t('accountDescriptions.login'),
    });
};
export const useFirstName = () => {
    const { t } = useTranslation('common');
    return useValidatedField('', {
        regex: /^[A-Za-z-'\s]{2,60}$/,
        errorMessage: t('accountDescriptions.name'),
    });
};
export const useSurname = () => {
    const { t } = useTranslation('common');
    return useValidatedField('', {
        regex: /^[A-Za-z-'\s]{2,60}$/,
        errorMessage: t('accountDescriptions.surname'),
    });
};
export const usePassword = () => {
    const { t } = useTranslation('common');
    return useValidatedField('', {
        regex: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\\])[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\\]{8,60}$/,
        errorMessage: t('accountDescriptions.password'),
    });
};
export const usePasswordConfirmation = (passwordValue) => {
    const { t } = useTranslation('common');
    return useValidatedField('', {
        compareValue: passwordValue,
        errorMessage: t('accountDescriptions.passwordConfirmation'),
    });
};
export const usePhoneNumber = () => {
    return useValidatedField('', {
        validateFn: (value) => value === '' || /^[+\d\s\-().]{0,50}$/.test(value),
        errorMessage: 'Invalid phone number',
    });
};
